import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    ...cookiePrivacyPolicyPopupStyles.drawer,
    cssOverrides: {
        scrim: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: unset;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 15px;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            background-color: #f0f4f3;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        bottom: auto;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 90%;
                        left: 5%;
                        right: 5%;
                        border-radius: 5px;
                        height: auto;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};
cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    ...cookiePrivacyPolicyPopupStyles.acceptGridItem,
    width: [8, 9, 3, 2, 2],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-basis: 78%;
                        max-width: 78%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],

                "max",
            )}
    `,
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    ...cookiePrivacyPolicyPopupStyles.acceptButton,
    css: css`
        width: 100%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 12px;
                `,
                null,
                null,
                css`
                    > span {
                        font-size: 14px;
                    }
                `,
                null,
            ])}
    `,
};

cookiePrivacyPolicyPopupStyles.closeGridItem = {
    ...cookiePrivacyPolicyPopupStyles.closeGridItem,
    width: [4, 3, 2, 1, 1],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 22%;
                    max-width: 22%;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};

cookiePrivacyPolicyPopupStyles.closeButton = {
    ...cookiePrivacyPolicyPopupStyles.closeButton,
    css: css`
        width: 100%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
